export default __webpack_public_path__ + "static/media/dislike_btn.1b12a61e.svg";